<template>
  <div>
      <v-card>
        <v-container>
          <h2 class="text-xs-center pb-2">{{$t('dashboard.create_new_data')}}</h2>
          <custom-text msg="custom-text.chart" class="mt-3"></custom-text>
          {{$t('dashboard.select_option')}}
          <div v-for="chart in chartTypes" :key="chart.id" :class="tableRowClass" :id="chartDataTypeId(chart.id)">
            <chart-row :chart="chart" :dialog="closeModal"></chart-row>
          </div>
        </v-container>

        <v-card-actions>
          <v-layout row justify-center class="pt-1 pb-1">
            <v-btn @click="closeModal" color="primary">{{$t('dashboard.close')}}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
  import CustomText from '../help/CustomText'
  import {mapState} from 'vuex'
  import ChartRow from './ChartRow'
  import {GET_DASHBOARD_AVAILABLE_CHART} from '../../store/action-types'
  import Helpers from '../../mixins/Helpers'
  import { SET_CREATE_CHART_DIALOG_VISIBILITY } from '../../store/mutation-types'

  export default {
    name: 'create-chart-modal',
    mixins: [Helpers],
    components: {ChartRow, CustomText},
    methods: {
      closeModal () {
        this.$store.commit(SET_CREATE_CHART_DIALOG_VISIBILITY, false)
      },
      chartDataTypeId (id) {
        return 'chart-data-type-' + id
      }
    },
    props: {},
    computed: {
      ...mapState({
        chartTypes: state => state.dashboard.availableCharts
      })
    },
    mounted () {
      this.$store.dispatch(GET_DASHBOARD_AVAILABLE_CHART)
    }
  }
</script>






// WEBPACK FOOTER //
// src/components/dashboard/CreateChartModal.vue